<template>
<v-layout row wrap>
  <template v-for="item in items">
    <v-chip outline :key="item.name" text-color="grey" class="ml-2">
      <v-avatar>
        <v-icon :color="isDisconnected ? 'grey' : item.colorIcon">{{ item.icon }}</v-icon>
      </v-avatar>
      {{ item.displayValue }}
    </v-chip>
  </template>
</v-layout>
</template>

<script>
export default {
  name: 'GatewayCompactItemAttributes',
  props: ['data', 'isDisconnected', 'commands'],
  computed: {
    items() {
      return [{
        name: 'load',
        icon: 'favorite',
        description: 'gateway.load_average',
        width: 4,
        colorIcon: 'red lighten-3',
        displayValue: this.data.load ? this.data.load[1] : '---',
        click: (this.commands || {})['load']
      }, {
        name: 'free_memory',
        icon: 'data_usage',
        description: 'gateway.free_memory',
        width: 4,
        colorIcon: 'brown lighten-3',
        displayValue: this.data.ram ? ((this.data.ram.free / this.data.ram.total * 100).toFixed(0) + '%') : '---',
        click: (this.commands || {})['free_memory']
      }, {
        name: 'latency',
        icon: 'network_check',
        description: 'gateway.latency',
        width: 4,
        colorIcon: 'green lighten-3',
        displayValue: this.data.latency ? this.data.latency : '---',
        click: (this.commands || {})['latency']
      }]
    }
  },
  methods: {
    layout(item) {
      return {
        [`xs${item.width || 12}`]: true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/gateway/GatewayCompactItemAttributes.vue